import { all, fork } from 'redux-saga/effects'

// App
import AppSagas from './app/sagas'
import ApiSagas from './api/sagas'
import AuthSagas from './auth/sagas'
import ExampleSagas from './example/sagas'
import ArticlesSagas from './articles/sagas'
import MessagesSagas from './messages/sagas'
import MailSagas from './mail/sagas'

function* loop() {
  yield all([
    ApiSagas.loop(),
    AppSagas.loop(),
    AuthSagas.loop(),
    ExampleSagas.loop(),
    ArticlesSagas.loop(),
    MessagesSagas.loop(),
    MailSagas.loop(),
  ])
}

export default function* rootSaga() {
  yield fork(loop)
}
